import React, { useState, lazy } from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, SendIcon } from 'lucide-react';
const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Here you would typically send the form data to a server
    console.log('Form submitted:', formData);
    setSubmitted(true);
    // Reset form after submission
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
    // Reset submission status after 5 seconds
    setTimeout(() => setSubmitted(false), 5000);
  };
  return <div className="bg-gray-50 min-h-screen" data-id="element-199">
      <div className="bg-[#1a3a6c] text-white py-16 relative overflow-hidden" data-id="element-200">
        <div className="absolute inset-0 z-0 opacity-20" data-id="element-201">
          <img src="https://images.unsplash.com/photo-1577563908411-5077b6dc7624?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Map background" className="w-full h-full object-cover" data-id="element-202" />
        </div>
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-203">
          <h1 className="text-4xl font-bold mb-6" data-id="element-204">Contact Us</h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-205">
            Your trusted appliance repair experts across the UK. We're here to
            help with all your appliance needs.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16" data-id="element-206">
        <div className="max-w-4xl mx-auto" data-id="element-207">
          <div className="text-center mb-12" data-id="element-208">
            <h2 className="text-3xl font-bold text-[#1a3a6c] mb-6" data-id="element-209">
              Your Trusted Appliance Repair Experts
            </h2>
            <p className="text-lg text-gray-700" data-id="element-210">
              Welcome to Opticore, your trusted choice for fast and reliable
              appliance repairs across the UK. Our expert engineers specialise
              in servicing essential household appliances. We're committed to
              delivering high-quality repairs, transparent pricing, and
              outstanding customer service.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-211">
            <div className="bg-white rounded-lg shadow-md p-8" data-id="element-212">
              <h3 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-213">
                Contact Details
              </h3>
              <div className="space-y-6" data-id="element-214">
                <div className="flex items-start" data-id="element-215">
                  <div className="bg-[#f0f9ff] p-2 rounded-full mr-4" data-id="element-216">
                    <MapPinIcon size={24} className="text-[#3b82f6]" data-id="element-217" />
                  </div>
                  <div data-id="element-218">
                    <h4 className="font-semibold text-gray-900 mb-1" data-id="element-219">
                      Address
                    </h4>
                    <p className="text-gray-700" data-id="element-220">
                      113 Church Rd, Birmingham B25 8UX
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-221">
                  <div className="bg-[#fff7ed] p-2 rounded-full mr-4" data-id="element-222">
                    <PhoneIcon size={24} className="text-[#f97316]" data-id="element-223" />
                  </div>
                  <div data-id="element-224">
                    <h4 className="font-semibold text-gray-900 mb-1" data-id="element-225">Phone</h4>
                    <p className="text-gray-700" data-id="element-226">
                      <a href="tel:08000554969" className="hover:text-[#3b82f6]" data-id="element-227">
                        0800 055 4969
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-228">
                  <div className="bg-[#f0fdf4] p-2 rounded-full mr-4" data-id="element-229">
                    <MailIcon size={24} className="text-green-500" data-id="element-230" />
                  </div>
                  <div data-id="element-231">
                    <h4 className="font-semibold text-gray-900 mb-1" data-id="element-232">Email</h4>
                    <p className="text-gray-700" data-id="element-233">
                      <a href="mailto:23tata0716@gmail.com" className="hover:text-[#3b82f6]" data-id="element-234">
                        23tata0716@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-235">
                  <div className="bg-[#fef2f2] p-2 rounded-full mr-4" data-id="element-236">
                    <ClockIcon size={24} className="text-red-500" data-id="element-237" />
                  </div>
                  <div data-id="element-238">
                    <h4 className="font-semibold text-gray-900 mb-1" data-id="element-239">
                      Opening Hours
                    </h4>
                    <p className="text-gray-700" data-id="element-240">
                      Monday to Friday: 9:00am – 5:00pm
                    </p>
                    <p className="text-gray-700" data-id="element-241">Saturday & Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md p-8" data-id="element-242">
              <h3 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-243">
                Send Us a Message
              </h3>
              {submitted ? <div className="bg-green-50 border border-green-200 rounded-md p-4 text-center" data-id="element-244">
                  <p className="text-green-800 font-medium" data-id="element-245">
                    Thank you for your message! We'll be in touch shortly.
                  </p>
                </div> : <form onSubmit={handleSubmit} data-id="element-246">
                  <div className="mb-4" data-id="element-247">
                    <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-248">
                      Name
                    </label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3b82f6]" required data-id="element-249" />
                  </div>
                  <div className="mb-4" data-id="element-250">
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-251">
                      Email
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3b82f6]" required data-id="element-252" />
                  </div>
                  <div className="mb-4" data-id="element-253">
                    <label htmlFor="phone" className="block text-gray-700 font-medium mb-2" data-id="element-254">
                      Phone
                    </label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3b82f6]" data-id="element-255" />
                  </div>
                  <div className="mb-4" data-id="element-256">
                    <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-257">
                      Message
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3b82f6]" required data-id="element-258"></textarea>
                  </div>
                  <button type="submit" className="bg-[#3b82f6] text-white py-2 px-6 rounded-md font-medium hover:bg-[#1a3a6c] transition-colors flex items-center justify-center" data-id="element-259">
                    <SendIcon size={18} className="mr-2" data-id="element-260" />
                    Send Message
                  </button>
                </form>}
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-261">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2431.6894112254694!2d-1.8291387230312757!3d52.45951377206759!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4870bb1f142b4e4f%3A0xf8c93b1e99e1a2a0!2s113%20Church%20Rd%2C%20Birmingham%20B25%208UX!5e0!3m2!1sen!2suk!4v1682521234567!5m2!1sen!2suk" width="100%" height="400" style={{
            border: 0
          }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-262"></iframe>
          </div>
        </div>
      </div>
    </div>;
};
export default ContactUs;